export const DEFAULT_PAGE_SIZE = 10;
// SQL Server has a limit of 2^31 - 1 rows per table
export const MAX_PAGE_SIZE = 2 ** 31 - 1;
export const GWI_DEFAULT_TABLE_PAGE_SIZE = 'gwi-default-table-page-size';
export const SHOULD_LOADS_REDIRECT = 'gwi-should-loads-redirect';

// google api key
export const GOOGLE_API_KEY = 'AIzaSyB-6L2AVTONUCmQTeEfe_1N-x8ilckxsyc';

export const GOOGLE_API_LOADER_OPTIONS = {
  apiKey: GOOGLE_API_KEY,
  version: 'weekly',
  libraries: ['places', 'geometry'],
  language: 'en',
};
